import React from 'react';
import { connect } from 'react-redux'
import { users_index } from '../actions'
import { Redirect } from 'react-router-dom'

import {
  is_logged_on,
  is_validating,
  is_manager
 } from "../helpers"

import Loading from './Loading';
import Pagination from './Pagination';
import UserFilters from './UserFilters'

import UserRow from './UserRow'

const mapStateToProps = (state) => {
  return {
    user: state.user,
    current_user: state.auth.current_user.data
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUsers: (page, filters) => { dispatch( users_index(page, filters) ) }
  }
}

class ConnectedUsers extends React.Component {
  constructor() {
    super()
    this.state={
      nowEditing: null,
      nowChangingPassword: null,
      filters: {}
    }
  }

  componentDidMount() {
    this.getUsers()
  }

  getUsers(page = 1) {
    const {filters} = this.state
    console.log(filters)
    this.props.getUsers(page, filters)
  }

  setFilters(filters) {
    this.setState({filters: filters})
    this.props.getUsers(1, filters)
  }

  initEdit(id) {
    this.setState({
      nowEditing: id,
      nowChangingPassword: null
    })
  }

  initChangePassword(id) {
    this.setState({
      nowEditing: null,
      nowChangingPassword: id
    })
  }

  render() {
    if ( !is_validating() && ( !is_logged_on() || !is_manager() ) ) {
      return <Redirect to="/" />
    }

    const {fetching, pagination} = this.props.user
    const { filters } = this.state

    const users = (this.props.user.items !== undefined && this.props.user.items.length > 0) ? this.props.user.items : []

    if ((fetching && users.length === 0 && Object.keys(filters).length === 0) || typeof(this.props.user.pagination) === "undefined") {
      return (
       <Loading />
      )
    }

    return (
      <div className="collection with-header">
        <div className="collection-header red darken-1 white-text">
          <span className="flow-text">Users List</span>
          <i className="material-icons right">people</i>
        </div>

        <UserFilters setFilters={this.setFilters.bind(this)} filters={this.state.filters}/>

        <table className="bordered striped highlight responsive-table users-list">
          <thead>
            <tr>
              <th>Name</th>
              <th>E-mail</th>
              <th>Account</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(function(item){
              return (
                <UserRow current_user={this.props.current_user} user={item}
                         initEdit={this.initEdit.bind(this)} initChangePassword={this.initChangePassword.bind(this)}
                         currentEdit={this.state.nowEditing} currentChangePassword={this.state.nowChangingPassword}
                         page={pagination.page} key={item.id}
                />
              )
            }, this)}
          </tbody>
        </table>
        <Pagination pagination={pagination} fetchPage={this.getUsers.bind(this)}/>
      </div>

    )
  }
}

const Users = connect(mapStateToProps, mapDispatchToProps)(ConnectedUsers)

export default Users



// WEBPACK FOOTER //
// ./src/js/components/Users.js